import React from 'react';
import InfoModal from './InfoModal';
import { useTranslation } from 'react-i18next';

// Shows how an order's total paid is made up (portion + delivery + cutting & packaging)
export default function OrderAmountModal({ order, onClose }) {
  const { t } = useTranslation();
  if (!order) return null;

  const portion = Number(order.amountPaid || 0);
  const delivery = Number(order.deliveryFee || 0);
  const cutting = Number(order.cuttingPackagingFee || 0);

  return (
    <InfoModal isOpen onClose={onClose} title={t('dialogs.payment.title')}>
      <div className="space-y-2 text-sm">
        <p>{t('dialogs.payment.portionPrice')} ${portion.toFixed(2)}</p>
        {delivery > 0 && <p>{t('dialogs.payment.deliveryFee')} ${delivery.toFixed(2)}</p>}
        {cutting > 0 && <p>{t('dialogs.payment.cuttingFee')} ${cutting.toFixed(2)}</p>}
        <p className="font-semibold border-t pt-2">{t('dialogs.payment.totalPaid')} ${(portion + delivery + cutting).toFixed(2)}</p>
      </div>
    </InfoModal>
  );
}
